// @ts-nocheck
import React, { useState, useEffect, useRef } from 'react';
import { CloseIcon, SearchIcon, PlusIcon } from './Icons';
import { uploadMediaFile } from '../utils/mediaUtils';
import { ReactionDisplay } from './ReactionDisplay';
import { createCustomReaction, searchCustomReactions, CustomReaction } from '../api';

interface EmojiPickerModalProps {
    isOpen: boolean;
    onClose: () => void;
    onEmojiSelect: (emoji: string) => void;
}

const EMOJI_CATEGORIES = [
    {
        name: 'Smileys & Emotion',
        emojis: ['😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '😋', '😛', '😝', '😜', '🤪', '🤨', '🧐', '🤓', '😎', '🤩', '🥳', '😏', '😒', '😞', '😔', '😟', '😕', '🙁', '☹️', '😣', '😖', '😫', '😩', '🥺', '😢', '😭', '😤', '😠', '😡', '🤬', '🤯', '😳', '🥵', '🥶', '😱', '😨', '😰', '😥', '😓', '🤗', '🤔', '🤭', '🤫', '🤥', '😶', '😐', '😑', '😬', '🙄', '😯', '😦', '😧', '😮', '😲', '🥱', '😴', '🤤', '😪', '😵', '🤐', '🥴', '🤢', '🤮', '🤧', '😷', '🤒', '🤕', '🤑', '🤠', '😈', '👿', '👹', '👺', '🤡', '👻', '💀', '☠️', '👽', '👾', '🤖', '🎃', '😺', '😸', '😻', '😼', '😽', '🙀', '😿', '😾']
    },
    {
        name: 'Gestures & Body',
        emojis: ['👋', '🤚', '🖐', '✋', '🖖', '👌', '🤏', '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '🖕', '👇', '☝️', '👍', '👎', '✊', '👊', '🤛', '🤜', '👏', '🙌', '👐', '🤲', '🤝', '🙏', '✍️', '💅', '🤳', '💪', '🦾']
    },
    {
        name: 'Hearts & Symbols',
        emojis: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔', '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '☮️', '✝️', '☪️', '🕉', '☸️', '✡️', '🔯', '🕎', '☯️', '☦️', '🛐', '⛎', '♈️', '♉️', '♊️', '♋️', '♌️', '♍️', '♎️', '♏️', '♐️', '♑️', '♒️', '♓️', '🆔', '⚛️', '🉑', '☢️', '☣️', '📴', '📳', '🈶', '🈚️', '🈸', '🈺', '🈷️', '✴️', '🆚', '💮', '🉐', '㊙️', '㊗️', '🈴', '🈵', '🈹', '🈲', '🅰️', '🅱️', '🆎', '🆑', '🅾️', '🆘', '❌', '⭕️', '🛑', '⛔️', '📛', '🚫', '💯', '💢', '♨️', '🚷', '🚯', '🚳', '🚱', '🔞', '📵', '🚭', '❗️', '❕', '❓', '❔', '‼️', '⁉️', '🔅', '🔆', '〽️', '⚠️', '🚸', '🔱', '⚜️', '🔰', '♻️', '✅', '🈯️', '💹', '❇️', '✳️', '❎', '🌐', '💠', 'Ⓜ️', '🌀', '💤', '🏧', '🚾', '♿️', '🅿️', '🈳', '🈂️', '🛂', '🛃', '🛄', '🛅', '🚹', '🚺', '🚼', '🚻', '🚮', '🎦', '📶', '🈁', '🔣', 'ℹ️', '🔤', '🔡', '🔠', '🆖', '🆗', '🆙', '🆒', '🆕', '🆓', '0️⃣', '1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣', '🔟', '🔢', '▶️', '⏸', '⏯', '⏹', '⏺', '⏏️', '⏭', '⏮', '⏩', '⏪', '⏫', '⏬', '◀️', '🔼', '🔽', '➡️', '⬅️', '⬆️', '⬇️', '↗️', '↘️', '↙️', '↖️', '↕️', '↔️', '↪️', '↩️', '⤴️', '⤵️', '🔀', '🔁', '🔂', '🔄', '🔃', '🎵', '🎶', '➕', '➖', '➗', '✖️', '♾', '💲', '💱', '™️', '©️', '®️', '👁‍🗨', '🔚', '🔙', '🔛', '🔝', '🔜', '〰️', '➰', '➿', '✔️', '☑️', '🔘', '⚪️', '⚫️', '🔴', '🔵', '🟤', '🟣', '🟢', '🟡', '🟠', '🟥', '🟦', '🟫', '⬛️', '⬜️', '🟪', '🟩', '🟨', '🟧', '📁', '📂', '🗂', '📅', '📆', '🗒', '🗓', '📇', '📈', '📉', '📊', '📋', '📌', '📍', '📎', '🖇', '📏', '📐', '✂️', '🗃', '🗄', '🗑']
    },
    {
        name: 'Activity & Objects',
        emojis: ['⚽️', '🏀', '🏈', '⚾️', '🥎', '🎾', '🏐', '🏉', '🥏', '🎱', '🪀', '🏓', '🏸', '🏒', '🏑', '🥍', '🏏', '🥅', '⛳️', '🪁', '🏹', '🎣', '🤿', '🥊', '🥋', '🛹', '🛷', '⛸', '🥌', '🎿', '⛷', '🏂', '🏋️‍♀️', '🏋️‍♂️', '🤼‍♀️', '🤼‍♂️', '🤸‍♀️', '🤸‍♂️', '⛹️‍♀️', '⛹️‍♂️', '🤺', '🤾‍♀️', '🤾‍♂️', '🏌️‍♀️', '🏌️‍♂️', '🏇', '🧘‍♀️', '🧘‍♂️', '🏄‍♀️', '🏄‍♂️', '🏊‍♀️', '🏊‍♂️', '🤽‍♀️', '🤽‍♂️', '🚣‍♀️', '🚣‍♂️', '🧗‍♀️', '🧗‍♂️', '🚵‍♀️', '🚵‍♂️', '🚴‍♀️', '🚴‍♂️', '🏆', '🥇', '🥈', '🥉', '🏅', '🎖', '🏵', '🎗', '🎫', '🎟', '🎪', '🤹‍♀️', '🤹‍♂️', '🎭', '🩰', '🎨', '🎬', '🎤', '🎧', '🎼', '🎹', '🥁', '🎷', '🎺', '🎸', '🪕', '🎻', '🎲', '♟', '🎯', '🎳', '🎮', '🎰', '🧩']
    }
];

export const EmojiPickerModal = ({ isOpen, onClose, onEmojiSelect }: EmojiPickerModalProps) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [customReactions, setCustomReactions] = useState<CustomReaction[]>([]);
    const [isUploading, setIsUploading] = useState(false);
    
    // Upload state
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [uploadFile, setUploadFile] = useState<File | null>(null);
    const [uploadPreview, setUploadPreview] = useState<string>('');
    const [uploadName, setUploadName] = useState('');
    const [uploadTags, setUploadTags] = useState('');
    const [uploading, setUploading] = useState(false);

    useEffect(() => {
        if (isOpen) {
            handleSearch('');
        } else {
            setSearchQuery('');
            setIsUploading(false);
            setUploadFile(null);
            setUploadPreview('');
            setUploadName('');
            setUploadTags('');
        }
    }, [isOpen]);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            handleSearch(searchQuery);
        }, 300);
        return () => clearTimeout(delayDebounceFn);
    }, [searchQuery]);

    const handleSearch = async (query: string) => {
        try {
            const results = await searchCustomReactions(query);
            setCustomReactions(Array.isArray(results) ? results : []);
        } catch (e) {
            console.error(e);
        }
    };

    const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setUploadFile(file);
            setUploadPreview(URL.createObjectURL(file));
            setIsUploading(true);
        }
    };

    const handleUploadSubmit = async () => {
        if (!uploadFile || !uploadName) return;
        setUploading(true);
        try {
            const currentUser = localStorage.getItem('currentUser') || 'anonymous';
            const url = await uploadMediaFile(uploadFile, currentUser);
            
            const mediaType = uploadFile.type.startsWith('video/') ? 'video' : 'image';
            const tags = uploadTags.split(' ').filter(t => t.trim().length > 0);
            
            const newReaction = await createCustomReaction({
                id: Math.random().toString(36).substr(2, 9),
                name: uploadName,
                url,
                mediaType,
                tags,
                creatorId: currentUser
            });
            
            setIsUploading(false);
            setUploadFile(null);
            setUploadPreview('');
            setUploadName('');
            setUploadTags('');
            
            setCustomReactions(prev => [newReaction, ...prev]);
        } catch (e) {
            console.error('Error uploading reaction', e);
        } finally {
            setUploading(false);
        }
    };

    const handleSelectReaction = (emoji: string) => {
        onEmojiSelect(emoji);
        try {
            const saved = localStorage.getItem('recent_emojis');
            const recents: string[] = saved ? JSON.parse(saved) : [];
            const filtered = recents.filter(x => x !== emoji);
            const newRecents = [emoji, ...filtered].slice(0, 14);
            localStorage.setItem('recent_emojis', JSON.stringify(newRecents));
        } catch (e) {
            console.error(e);
        }
    };

    if (!isOpen) return null;

    const filteredCategories = EMOJI_CATEGORIES.map(c => ({
        ...c,
        emojis: c.emojis.filter(e => e.includes(searchQuery) || searchQuery === '')
    })).filter(c => c.emojis.length > 0 || searchQuery === '');

    return (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-[100]" onClick={onClose}>
            <div
                className="bg-gray-900 w-full max-w-sm mx-4 rounded-3xl shadow-2xl overflow-hidden border border-gray-700 flex flex-col max-h-[80vh]"
                onClick={e => e.stopPropagation()}
                data-emoji-picker="true"
            >
                <div className="p-4 border-b border-gray-800 flex justify-between items-center bg-gray-900/50">
                    <h3 className="text-lg font-bold text-white">Reactions</h3>
                    <div className="flex items-center gap-2">
                        {!isUploading && (
                            <button onClick={() => fileInputRef.current?.click()} className="p-1.5 bg-blue-600 hover:bg-blue-500 rounded-full transition-colors text-white text-xs font-bold px-3">
                                + Custom
                            </button>
                        )}
                        <input 
                            type="file" 
                            ref={fileInputRef} 
                            className="hidden" 
                            accept="image/*,video/*" 
                            onChange={handleFileSelect} 
                        />
                        <button onClick={onClose} className="p-1 hover:bg-white/10 rounded-full transition-colors">
                            <CloseIcon className="w-5 h-5 text-gray-400" />
                        </button>
                    </div>
                </div>

                {isUploading ? (
                    <div className="p-6 flex flex-col gap-4">
                        <h4 className="text-white font-bold text-center">Upload Custom Reaction</h4>
                        <div className="w-32 h-32 mx-auto bg-black/50 rounded-2xl flex items-center justify-center overflow-hidden border border-white/10">
                            {uploadFile?.type.startsWith('video/') ? (
                                <video src={uploadPreview} className="w-full h-full object-cover" autoPlay loop muted playsInline />
                            ) : (
                                <img src={uploadPreview} className="w-full h-full object-cover" alt="preview" />
                            )}
                        </div>
                        <input 
                            type="text" 
                            placeholder="Reaction Name (e.g. pepe_happy)" 
                            className="w-full bg-black/40 border border-white/10 rounded-xl px-4 py-2 text-white outline-none focus:border-blue-500"
                            value={uploadName}
                            onChange={e => setUploadName(e.target.value.replace(/\s+/g, '_').toLowerCase())}
                        />
                        <input 
                            type="text" 
                            placeholder="Tags (space separated)" 
                            className="w-full bg-black/40 border border-white/10 rounded-xl px-4 py-2 text-white outline-none focus:border-blue-500 text-sm"
                            value={uploadTags}
                            onChange={e => setUploadTags(e.target.value)}
                        />
                        <div className="flex gap-2 mt-2">
                            <button onClick={() => setIsUploading(false)} className="flex-1 py-2 rounded-xl bg-white/10 hover:bg-white/20 text-white font-bold transition-all">
                                Cancel
                            </button>
                            <button onClick={handleUploadSubmit} disabled={!uploadName || uploading} className="flex-1 py-2 rounded-xl bg-blue-600 hover:bg-blue-500 disabled:opacity-50 text-white font-bold transition-all">
                                {uploading ? 'Uploading...' : 'Save Reaction'}
                            </button>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="p-3 border-b border-white/5">
                            <div className="relative">
                                <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                                <input
                                    type="text"
                                    placeholder="Search reactions..."
                                    className="w-full bg-black/40 border border-white/10 rounded-xl pl-9 pr-4 py-2 text-white outline-none focus:border-blue-500 text-sm"
                                    value={searchQuery}
                                    onChange={e => setSearchQuery(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="flex-grow overflow-y-auto p-4 custom-scrollbar">
                            {customReactions.length > 0 && (
                                <div className="mb-6">
                                    <h4 className="text-xs font-bold text-purple-400 uppercase tracking-widest mb-3 px-1">Custom Reactions</h4>
                                    <div className="grid grid-cols-5 gap-3">
                                        {customReactions.map(reaction => (
                                            <button
                                                key={reaction.id}
                                                onClick={() => handleSelectReaction(`custom-${reaction.mediaType === 'video' ? 'vid' : 'img'}:${reaction.url}`)}
                                                className="w-12 h-12 bg-black/20 hover:bg-white/10 rounded-xl transition-all hover:scale-110 flex items-center justify-center p-1 relative group"
                                            >
                                                {reaction.mediaType === 'video' ? (
                                                    <video src={reaction.url} className="w-full h-full object-cover rounded-lg" autoPlay loop muted playsInline />
                                                ) : (
                                                    <img src={reaction.url} className="w-full h-full object-cover rounded-lg" alt={reaction.name} />
                                                )}
                                                <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 bg-black text-white text-[9px] px-1.5 py-0.5 rounded opacity-0 group-hover:opacity-100 whitespace-nowrap pointer-events-none z-10 font-bold">
                                                    :{reaction.name}:
                                                </div>
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {!searchQuery && (() => {
                                const saved = typeof window !== 'undefined' ? localStorage.getItem('recent_emojis') : null;
                                const recentEmojis: string[] = saved ? JSON.parse(saved) : [];
                                if (recentEmojis.length === 0) return null;
                                return (
                                    <div className="mb-6">
                                        <h4 className="text-xs font-bold text-blue-400 uppercase tracking-widest mb-3 px-1 flex items-center gap-2">
                                            <span className="w-1.5 h-1.5 rounded-full bg-blue-400 animate-pulse"></span>
                                            Recently Used
                                        </h4>
                                        <div className="grid grid-cols-7 gap-2">
                                            {recentEmojis.map(emoji => (
                                                <button
                                                    key={`recent-${emoji}`}
                                                    onClick={() => handleSelectReaction(emoji)}
                                                    className="text-2xl hover:bg-white/10 p-1.5 rounded-lg transition-all hover:scale-125 flex items-center justify-center"
                                                >
                                                    <ReactionDisplay emoji={emoji} />
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                );
                            })()}

                            {(!searchQuery || searchQuery.length < 2) && filteredCategories.map(category => (
                                <div key={category.name} className="mb-6">
                                    <h4 className="text-xs font-bold text-gray-500 uppercase tracking-widest mb-3 px-1">{category.name}</h4>
                                    <div className="grid grid-cols-7 gap-2">
                                        {category.emojis.map(emoji => (
                                            <button
                                                key={emoji}
                                                onClick={() => handleSelectReaction(emoji)}
                                                className="text-2xl hover:bg-white/10 p-1.5 rounded-lg transition-all hover:scale-125 flex items-center justify-center"
                                            >
                                                <ReactionDisplay emoji={emoji} />
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};
